import { Reveal } from "@/components/Reveal";
import { HOME } from "@/constants/testIds";

export const About = () => (
    <section id="about" data-testid={HOME.about} aria-label="what this is — about deep end grooves" className="border-b border-[var(--rule)]">
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16 py-20 sm:py-24 lg:py-32">
            <Reveal>
                <p className="eyebrow text-[var(--terracotta-ink)]">01 — what this is</p>
                <h2 className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl max-w-[22ch]">what this is — a hand-picked deep house playlist</h2>
            </Reveal>

            <Reveal delay={0.05}>
                <div
                    data-testid={HOME.aboutBody}
                    className="mt-12 sm:mt-14 space-y-7 text-base sm:text-lg max-w-[72ch]"
                    style={{ lineHeight: 1.7 }}
                >
                    <p>
                        Deep End Grooves is a listening project maintained by an anonymous curator that would rather
                        keep the spotlight on the records.
                    </p>
                    <p>
                        The scope is deliberately narrow: deep house, deep tech and minimal deep tech, dub techno, dub
                        lounge. Different rooms in the same building. What connects them is a preference for restraint —
                        music built on repetition and space rather than incident, where the interest sits in the low end,
                        the shuffle of a hi-hat, and the way a chord decays into reverb, rather than in any obvious hook.
                    </p>
                    <p>
                        Selections are made by hand and by ear. A record from 2012 that sold three hundred copies sits
                        next to something released last Friday; the year is not a useful sorting mechanism. Much of what
                        ends up here surfaced from long sessions in the back catalogues of small labels — Romanian
                        minimal imprints, the long tail of Basic Channel, the deep house operations that have run
                        quietly for two decades without troubling anyone&apos;s chart.
                    </p>
                    <p>The standard is simple. Everything deep. All the time.</p>
                </div>
            </Reveal>

            <Reveal delay={0.1}>
                <p className="eyebrow mt-14 text-[var(--terracotta-ink)]">UPDATED WEEKLY</p>
            </Reveal>
        </div>
    </section>
);
